import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { StyleSheet } from 'react-native';
import { theme } from '@xbto/design-system';
import { Col, Row, Surface, TextBody } from '../../atoms';
import { useBreakpoints } from '../../hooks';
import { InfoPopover } from '../info-popover';
export const MetricCard = memo(({ children, label, help }) => {
    const { breakpoints } = useBreakpoints(500);
    return (_jsxs(Surface, { variant: "tertiary", style: StyleSheet.flatten([
            $.container,
            breakpoints.LESS_THAN_S && $.container_S,
        ]), children: [_jsxs(Row.L, { children: [_jsx(TextBody, { small: true, lhFull: true, children: label }), !!help && (_jsx(Col, { ml: "1", children: _jsx(InfoPopover, { placement: "auto-end", content: help }) }))] }), children] }));
});
const $ = StyleSheet.create({
    container: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        borderRadius: theme.radius.md,
        padding: theme.spacing[4],
        rowGap: theme.spacing[3],
        minHeight: 70,
    },
    container_S: {
        minHeight: 44,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
});
